import { useQuery } from "@tanstack/react-query";

const useGetAllStudies = () => {
  const userId = localStorage.getItem("uI");
  const user_id = userId - 786;
  const {
    refetch,
    isLoading,
    isError,
    error,
    isSuccess,
    data: getAllStudiesList = [],
  } = useQuery({
    queryKey: ["GetAllStudies"],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/getStudies`
      );
      const data = await res.json();
      // console.log("studies list", data.data.studies);
      return data.data.studies;
    },
  });

  return [getAllStudiesList, isLoading, isError, error, isSuccess, refetch];
};

export default useGetAllStudies;
